<template>
  <BaseLabel class="label-case" :type="type"><slot></slot></BaseLabel>
</template>

<script>
import BaseLabel from './Label.vue'
export default {
  components: {
    BaseLabel
  },
  props: {
    type: {
      type: Number,
      default: 0
    }
  }
}
</script>

<style lang="postcss" scoped>
@import "index.css";
.label-case {
  @media (--mediaPc) {
    font-size: 12px;
    height: 20px;
  }
  @media (--mediaMobile) {
    font-size: var(--textSize6);
    height: calc(28px / var(--scale));
  }
}
</style>



// WEBPACK FOOTER //
// src/components/label/ReplyLabel.vue